// extracted by mini-css-extract-plugin
export default {"container":"RiskModeling_container__8MRXY","title":"RiskModeling_title__N+7Ez"};